import type { i18n as I18n } from 'i18next';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/languages';

/**
 * What the app showed next to a legal box, sent with the acceptance and kept by
 * the server as proof (VOL-199): the interface language and the box's sentence.
 */
export interface ShownConsent {
  language: SupportedLanguage;
  cguText?: string;
  cgvText?: string;
  waiverText?: string;
}

/** Language as the server knows it ("de", never "de-DE"), French when unknown. */
export function consentLanguage(i18n: Pick<I18n, 'language'>): SupportedLanguage {
  return SUPPORTED_LANGUAGES.find((l) => i18n.language?.startsWith(l)) ?? 'fr';
}

/** The sentence a reader saw: `<cgv>Conditions</cgv>` loses its link tags, keeps its words. */
export function shownSentence(translated: string): string {
  return translated.replace(/<\/?[a-z][a-z0-9]*>/gi, '').trim();
}
